
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","height":"28","viewBox":"0 0 30 28","width":"30","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#b2895f"}},[_c('path',{attrs:{"clip-rule":"evenodd","d":"m8.89754 9.66675c-1.06657 0-1.9312.82915-1.9312 1.85185v2.1164h-2.4022c-.56811 0-1.04339.4136-1.09836.9558l-.95522 9.4214c-.12612 1.2439.89339 2.3212 2.19672 2.3212h10.58542c1.3034 0 2.3229-1.0773 2.1967-2.3212l-.9552-9.4214c-.0549-.5422-.5302-.9558-1.0983-.9558h-2.4001v-2.1164c0-1.0227-.8646-1.85185-1.9312-1.85185zm2.48296 3.96825v-2.1164c0-.1461-.1235-.2646-.2759-.2646h-2.20706c-.15237 0-.27589.1185-.27589.2646v2.1164zm-7.2224 10.5308.88398-8.7187c.01294-.1277.12041-.2248.24872-.2248h9.4184c.1283 0 .2358.0971.2487.2248l.884 8.7187c.0315.311-.2233.5803-.5492.5803h-10.58542c-.32583 0-.58071-.2693-.54918-.5803z","fill-rule":"evenodd"}}),_c('path',{attrs:{"d":"m22 3c-2.7572 0-5 2.24281-5 5 0 2.7572 2.2428 5 5 5s5-2.2428 5-5c0-2.75719-2.2428-5-5-5zm0 .73171c2.3618 0 4.2683 1.90646 4.2683 4.26829 0 2.3618-1.9065 4.2683-4.2683 4.2683s-4.2683-1.9065-4.2683-4.2683c0-2.36183 1.9065-4.26829 4.2683-4.26829zm0 .60975c-.202 0-.3659.16388-.3659.36586v3.29268c0 .13529.0739.25295.183.31632l2.6409 1.52439c.1749.10099.3983.04144.4993-.13339.101-.17484.0414-.39825-.1334-.49925l-2.458-1.41768v-3.08305c0-.20197-.1639-.36585-.3659-.36585z"}})])])
          )
        }
      }
    